import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_INGREDIENT_IMAGE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateIngredientImageDetailsArgs } from '../graphql/transformers'
import { UPDATE_INGREDIENT_IMAGE_DETAILS } from '../redux/action-types'

const useUpdateIngredientImageDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isImageDetailsLoading, imageDetailsError } = useSelector(
    store => store.cuisineTypes.cuisineType,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_INGREDIENT_IMAGE_DETAILS_MUTATION,
        { id, data: transformToUpdateIngredientImageDetailsArgs(data) },
        dispatch,
        UPDATE_INGREDIENT_IMAGE_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isImageDetailsLoading, error: imageDetailsError },
  ]
}

export default useUpdateIngredientImageDetailsMutation
